import React from 'react'

export default ({
    selectedMatrix,
    setSelectedMatrix,
    analyteList,
    displayMatrixWindowDropdown,
    colorClass,
    matrixList,
}) => {
    if (!displayMatrixWindowDropdown) {
        return null
    }
    
    return (
        <div className="analyteDropdownWrapper">
            {matrixList.map((option, idx) => {
                const active = selectedMatrix.Code === option.Code
                return (
                    <div
                        key={`timeoption-${idx}`}
                        className={`analyteOptionWrapper ${
                            active ? 'activeOption ' + colorClass : ''
                        }`}
                        onClick={() => {
                            setSelectedMatrix(option)
                        }}
                    >
                        <span className="analyteOptionText">
                            {option.CodeDescription}
                        </span>
                    </div>
                )
            })}
        </div>
    )
}
